<div class="button-wrap" [ngClass]="{ 'icon-only': !showMainButton }">
  <button *ngIf="showMainButton" class="btn" [ngClass]="{ 'btn-selected': isSelected() }" (click)="onClick(data.key)">
    {{ displayLabel }}
  </button>

  <button *ngIf="isResetVisible" type="button" mat-icon-button class="reset-icon-btn" [style.height]="data?.iconHeight"
    [style.width]="data?.iconHeight" [style.margin-right]="data?.marginright" matTooltip="Reset filters"
    matTooltipPosition="above" (click)="onResetClick($event)">
    <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
  </button>

  <button *ngIf="isInsightVisible" type="button" mat-icon-button class="insight-icon-btn"
    [style.height]="data?.iconHeight" [style.width]="data?.iconHeight" [matTooltip]="insightTooltipText"
    matTooltipClass="insight-tooltip-panel" matTooltipPosition="above" (click)="$event.stopPropagation()">
    <mat-icon>info</mat-icon>
  </button>
</div>